import {
  Overview as OverviewIcon,
  Grantees as GranteesIcon,
} from "../../Components/Icon";

import Overview from "../../Pages/Grantees/Overview";
import Grantees from "../../Pages/Grantees/Grantees";

const navigation = {
  header: "Grantees",
  links: [
    { text: "Overview", icon: OverviewIcon, route: "overview", component: Overview },
    {
      text: "Grantees",
      icon: GranteesIcon,
      route: "grantees",
      component: Grantees,
    },
  ],
};
export default navigation;
